import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TabSwitchDetector from './TabSwitchDetector';

const FullScreenEnabler = () => {
  const [, setIsFullscreen] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [, setCancelCount] = useState(0);
  const navigate = useNavigate();

  const handleFullscreenChange = () => {
    const fullscreen = !!document.fullscreenElement;
    setIsFullscreen(fullscreen);
    setShowDialog(!fullscreen);
  };

  const requestFullscreen = () => {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    } else if (document.documentElement.mozRequestFullScreen) { // Firefox
      document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.webkitRequestFullscreen) { // Chrome, Safari and Opera
      document.documentElement.webkitRequestFullscreen();
    } else if (document.documentElement.msRequestFullscreen) { // IE/Edge
      document.documentElement.msRequestFullscreen();
    }
  };

  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('msfullscreenchange', handleFullscreenChange);
    handleFullscreenChange();

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('msfullscreenchange', handleFullscreenChange);
    };
  }, []);

const handleCancel = () => {
  setCancelCount(prevCount => prevCount + 1);
  navigate(-1);
};


  return (
    <div id="fullscreen-entry-container">
      <TabSwitchDetector />

      {showDialog && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
          id="fullscreen-entry-overlay"
        >
          <div
            className="bg-white rounded-lg p-6 shadow-lg w-11/12 md:w-1/3"
            id="fullscreen-entry-dialog"
          >
            <h2 className="text-lg font-semibold mb-4" id="fullscreen-entry-title">
              Enter Fullscreen
            </h2>
            <p className="mb-4" id="fullscreen-entry-message">
              Please enter fullscreen mode to proceed with the exam.
            </p>

            <div className="flex justify-end" id="fullscreen-entry-actions">
              <button
                id="fullscreen-allow-btn"
                onClick={requestFullscreen}
                className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 transition"
              >
                Allow
              </button>
              <button
                id="fullscreen-back-btn"
                onClick={handleCancel}
                className="ml-2 bg-gray-300 py-2 px-4 rounded hover:bg-gray-400 transition"
              >
                Back
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FullScreenEnabler;
